export default "__VITE_ASSET__DpqyzlYk__"